import { useLocalTime } from '@repo/toolkit/use-local-time'
import Badge from '@repo/ui/badge'
import { ClockIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { getCenter } from '../../../api/centers/get-center'
import CenterGlobalViewInformationSection from '../../../components/pages/centers/center-global-view/center-global-view-information-section'
import CenterGlobalViewJourneyTripAndStaffSection from '../../../components/pages/centers/center-global-view/center-global-view-journey-trip-and-staff-section'
import CenterGlobalViewStatisticsSection from '../../../components/pages/centers/center-global-view/center-global-view-statistics-section'
import CenterMainStaffBadgeInfo from '../../../components/pages/centers/center-main-staff-badge-info'
import { Props } from '../../../components/pages/host-families/host-family-ol-comments-table'
import CenterLecCommentTable from '../../../components/pages/ols/centers/center-tab-views/center-placement/center-comments/center-lec-comment-table'
import { useObserver } from '../../../lib/contexts/observer'

const CenterGlobalView = ({ id }: Props) => {
  const queryClient = useQueryClient()
  const { data: center } = useQuery({
    queryKey: ['single-center', id],
    queryFn: () => getCenter(id)
  })

  useObserver({
    key: 'center-global-view',
    update: () => {
      queryClient.invalidateQueries({ queryKey: ['single-center', id] })
    }
  })

  const timeZone = center?.journeyPlace?.timezone ?? center?.journeyPlace?.country?.timezone
  const localTime = useLocalTime(timeZone)

  if (!center) return <Loader center />

  return (
    <div>
      <div className="h-6" />
      <div className="flex items-center justify-between">
        <CenterMainStaffBadgeInfo id={id} />
        <InnerBox className="flex flex-row p-2 items-center gap-2">
          <Badge icon={<ClockIcon />} />
          <Typography variant="secondary-body">
            Heure locale :
            {localTime ? (
              <span className="font-semibold font-mono"> {localTime}</span>
            ) : (
              <span className="font-semibold" title="Fuseau horaire non renseigné pour ce pays">
                {' '}
                -
              </span>
            )}
          </Typography>
        </InnerBox>
      </div>

      <div className="h-6" />
      <CenterGlobalViewInformationSection center={center} />
      <div className="h-5" />
      <CenterGlobalViewJourneyTripAndStaffSection center={center} />
      <div className="h-5" />
      <CenterGlobalViewStatisticsSection center={center} />
      <div className="h-5" />
      <CenterLecCommentTable id={id} bodyColorVariant="white" />
    </div>
  )
}

export default CenterGlobalView
